<template>
  <div>
    <h1>Editar Concedente</h1>
    <b-card no-body>
      <div v-if="isPending" class="text-center py-4">
        <b-spinner label="Carregando concedente" />
      </div>
      <the-form v-else :key="id" @saved="refetch" />
    </b-card>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router/dist/composables.js";
import { useNamespacedActions } from "vuex-composition-helpers";
import { useQuery } from "@/composables/useQuery";
import TheForm from "../Components/Form.vue";

const route = useRoute();
const { ActionShow } = useNamespacedActions("concedentes", ["ActionShow"]);

const queryKey = ["concedentes", "editar", computed(() => route.params.id)];

const id = computed(() => route.params.id);

const { isPending, refetch } = useQuery({
  key: queryKey,
  queryFn: () => ActionShow(id.value),
});
</script>
